exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dropbox[data-v-26f2f05e]{outline:2px dashed #aaa;color:#7c7c7c;padding:10px;position:relative;cursor:pointer;background-color:#fff;background-repeat:no-repeat;background-size:contain;background-position:50% 50%;display:flex;align-items:center;justify-content:center;margin-bottom:10px}.dropbox .input-file[data-v-26f2f05e]{opacity:0;width:100%;height:100px;position:absolute;cursor:pointer}.dropbox p[data-v-26f2f05e]{text-align:center;padding:10px 0}.dropbox[data-v-26f2f05e]:hover{color:#fefcfc;outline:2px dashed #e45a3f}p[data-v-26f2f05e]{margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26f2f05e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./scss/next/_wp_variables.scss","./node_modules/bootstrap/scss/_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/_eng/globals/dupload.vue
// module id = 1737
// module chunks = 142